import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  GuardResult,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService, RoutingService } from '@spartacus/core';
import { CmsPageGuard } from '@spartacus/storefront';
import { EMPTY, Observable, of, zip } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { GenGoogleAnalyticsService } from '../services/google-analytics.service';

@Injectable({
  providedIn: 'root',
})
export class GenLoginGuard {
  constructor(
    protected authService: AuthService,
    protected cmsPageGuard: CmsPageGuard,
    protected googleAnalyticsService: GenGoogleAnalyticsService,
    private routingService: RoutingService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<GuardResult> {
    return zip(this.shouldRenderCMSPage(), this.isRedirectedFromD360()).pipe(
      take(1),
      switchMap(([shouldRenderCMSPage, isRedirectedFromD360]) => {
        if(isRedirectedFromD360) {
          this.googleAnalyticsService.sendGaEvent('login', {
            method: "D360 Shop Button"
          });
        }
        
        if (shouldRenderCMSPage) {
          return this.cmsPageGuard.canActivate(route, state);
        } else {
          const redirected = this.authService.loginWithRedirect();
          if (!redirected) {
            return of(false);
          }
          return EMPTY;
        }
      })
    );
  }

  protected shouldRenderCMSPage(): Observable<boolean> {
    return of(true);
  }

  protected isRedirectedFromD360(): Observable<boolean> {
    return this.routingService.getRouterState().pipe(
      switchMap(state => of(state.nextState.queryParams['salesOrgId'] !== undefined && state.nextState.queryParams['companyNumber'] !== undefined))
    )
  }
}
